import { useMemo } from 'react'
import { groupBy, map, sortBy } from 'lodash'
import { useDataValue } from 'Simple/Data.js'
import { parseLocalDateStringToZonedDate, formatTzDate } from 'Data/format.js'

let PM_MINUTE_THRESHOLD = 12 * 60

export default function useDataTransform(props, data) {
  let time_zone_id = useDataValue({
    context: 'tab',
    path: 'selected.time_zone_id',
    viewPath: props.viewPath,
  })

  return useMemo(() => {
    if (!data) return data

    return sortBy(
      map(groupBy(data, 'date'), group => {
        let date = group[0].date
        let parsedDate = parseLocalDateStringToZonedDate(date, time_zone_id)
        let amSlotsCount = 0
        let pmSlotsCount = 0

        group.forEach(slot => {
          if (slot.start_min < PM_MINUTE_THRESHOLD) {
            amSlotsCount += 1
          } else {
            pmSlotsCount += 1
          }
        })

        return {
          id: date, // for list
          date: parsedDate,
          line1: formatTzDate(parsedDate, 'EEEE, MMMM dd, yyyy', time_zone_id),
          line2: `Open slots - ${amSlotsCount} in AM, ${pmSlotsCount} in PM`,
        }
      }),
      'date'
    )
  }, [data, time_zone_id])
}
